import React from "react";
import Breadcrumbs from "../Breadcrumbs";
import { SiteWrap } from "luna-react";
import { sections } from "../../config";
import "./scss/Header.scss";
import { Link } from "redux-little-router";
import Hero from "./Hero";

export const HeaderMenuItem = ({ text, link }) => {
  return (
    <li className="nav_item">
      <Link className="nav_link" href={link}>
        {text}
      </Link>
    </li>
  );
};

const Header = () => {
  return (
    <header className="header__wrapper">
      <SiteWrap>
        <div className="top_bar">
          <input className="menu_toggle" id="menu_toggle" type="checkbox" />
          <label htmlFor="menu_toggle" className="" />
          <Link href="/" className="logo">
            Privacy Hub Home
          </Link>
          <ul className="nav">
            {sections.map((item) => (
              <HeaderMenuItem
                key={item.link}
                link={item.link}
                text={item.text}
              />
            ))}
          </ul>
        </div>
        <div className="bottom_bar">
          <Breadcrumbs />
        </div>
        <Hero image={null} />
      </SiteWrap>
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js